import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// POST data source

const postSpokePending = (state: AppState) => state.postSpoke.pending;
const postSpoke = (state: AppState) => state.postSpoke.spoke;
const postSpokeError = (state: AppState) => state.postSpoke.error;

export const postSpokePendingSelector = createSelector(
  postSpokePending,
  (pending) => pending
);
export const postSpokeSelector = createSelector(postSpoke, (spoke) => spoke);
export const postSpokeErrorSelector = createSelector(
  postSpokeError,
  (error) => error
);

//Spokes List
const fetchSpokePending = (state: AppState) => state.fetchSpokes.pending;
const fetchSpoke = (state: AppState) => state.fetchSpokes.spokes;
const fetchSpokeError = (state: AppState) => state.fetchSpokes.error;

export const fetchSpokePendingSelector = createSelector(fetchSpokePending,(pending) => pending);
export const fetchSpokeSelector = createSelector(fetchSpoke, (spoke) => spoke);
export const fetchSpokeErrorSelector = createSelector(fetchSpokeError, (error) => error);

//Spokes List Details (page load)
const fetchSpokeListPending = (state: AppState) => state.spokeList.pending;
const fetchSpokeList = (state: AppState) => state.spokeList.spokesList;
const fetchSpokeListError = (state: AppState) => state.spokeList.error;

export const fetchSpokeListPendingSelector = createSelector(fetchSpokeListPending,(pending) => pending);
export const fetchSpokeListSelector = createSelector(fetchSpokeList, (spokeList) => spokeList);
export const fetchSpokeListErrorSelector = createSelector(fetchSpokeListError, (error) => error);

//Spoke list by Id
const fetchSpokeByIdPending = (state: AppState) => state.fetchSpokeById.pending;
const fetchSpokeById = (state: AppState) => state.fetchSpokeById.spoke;
const fetchSpokeByIdError = (state: AppState) => state.fetchSpokeById.error;

export const fetchSpokeByIdPendingSelector = createSelector(
  fetchSpokeByIdPending,
  (pending) => pending
);
export const fetchSpokebyIdSelector = createSelector(
  fetchSpokeById,
  (spoke) => spoke
);
export const fetchSpokeByIdErrorSelector = createSelector(
  fetchSpokeByIdError,
  (error) => error
);

// DELETE source

const deleteSpokePending = (state: AppState) => state.deleteSpoke.pending;
const deleteSpoke = (state: AppState) => state.deleteSpoke.success;
const deleteSpokeError = (state: AppState) => state.deleteSpoke.error;

export const deleteSpokeSelector = createSelector(deleteSpoke, (source) => source);
export const deleteSpokePendingSelector = createSelector(deleteSpokePending,(pending) => pending);
export const deleteSpokeErrorSelector = createSelector(deleteSpokeError, (error) => error);
